import { offsetLimitPagination } from "@apollo/client/utilities"

const computeListCacheKey = (args) => JSON.stringify(args.filter)

const uploadTypePolicies = {
  root: {},
  scoped: {
    UploadsQuery: {
      fields: {
        list: offsetLimitPagination(computeListCacheKey),
        count: {
          keyArgs: computeListCacheKey
        }
      }
    }
  }
}

export { uploadTypePolicies }
